import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../MuroEditorLoadableWrapper';
import { MuroProps } from '../../types';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableEditor = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "muro_editor" */
        './Mini'
      )
  )
);

const MiniLoadable: React.FC<MuroProps> = props => {
  return (
    <EditorLoadableWrapper>
      <LoadableEditor {...props} />
    </EditorLoadableWrapper>
  );
};
MiniLoadable.displayName = 'MiniLoadable';

export default MiniLoadable;
